import { useQuery } from "@tanstack/react-query";
import { getSiteSettings, SITE_SETTINGS_DEFAULTS } from "../services/settings.service";

export function useSiteSettings() {
  const query = useQuery({
    queryKey: ["site-settings"],
    queryFn: getSiteSettings,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    settings: query.data || SITE_SETTINGS_DEFAULTS,
  };
}
